<template lang="pug">


  .mode-switch
    img(style="display:none" ref="pattern" src="~assets/ui/pattern2.png")
    img(style="display:none" ref="liqtrans" src="~assets/ui/liqtrans.png")
    img(style="display:none" ref="transDots" src="~assets/ui/transDots.png")
    canvas.mode-trans(ref="trans")



</template>

<script>
import { mapState, mapMutations } from 'vuex'
import * as MODES from 'src/config/modes'
import Raf from 'src/helpers/Raf'

export default {
  name: 'mode-switch',
  components: {},
  data() {
    return {
      timeline: 0,
      timeline2: 1,
      timeline3: 0,
      cx: 0,
      switchMode: false,
      MODES,
      modeTo: '',
      offset: 0.001,
      frame: 0,

      liqtransP: [
        {w:450, h:800, x: 1, y:1},
        {w:450, h:800, x: 1357, y:1605},
        {w:450, h:800, x: 3165, y:1},
        {w:450, h:800, x: 2261, y:803},
        {w:450, h:800, x: 2261, y:1605},
        {w:450, h:800, x: 2713, y:803},
        {w:450, h:800, x: 2713, y:1605},
        {w:450, h:800, x: 3165, y:803},
        {w:450, h:800, x: 3165, y:1605},
        {w:450, h:800, x: 1, y:803},
        {w:450, h:800, x: 1, y:1605},
        {w:450, h:800, x: 453, y:1},
        {w:450, h:800, x: 453, y:803},
        {w:450, h:800, x: 453, y:1605},
        {w:450, h:800, x: 905, y:1},
        {w:450, h:800, x: 905, y:803},
        {w:450, h:800, x: 905, y:1605},
        {w:450, h:800, x: 1357, y:1},
        {w:450, h:800, x: 1357, y:803},
        {w:450, h:800, x: 1809, y:1},
        {w:450, h:800, x: 1809, y:803},
        {w:450, h:800, x: 1809, y:1605},
        {w:450, h:800, x: 2261, y:1},
        {w:450, h:800, x: 2713, y:1}
      ],
      liqtransFlip: false
    }
  },
  props: {

  },
  computed: {
    ...mapState('app', ['mode', 'currSceneIdx']),

  },
  beforeMount(){
    if (this.mode){
      this.modeTo = '大人'
    } else {
      this.modeTo = '小孩'
    }
  },
  mounted() {
    // let w = window.innerWidth
    // let h = window.innerHeight
    // let ph = h*2
    // let pw = ph*1107/867
    // this.$refs.pattern.style.width = pw+'px'
    // this.$refs.pattern.style.height = ph+'px'
    //
    // let pww = pw/3
    // //let offset = this.idx*w % pww
    // //this.$refs.pattern.style.left = `-${offset}px`
    //
    // this.cx = w/pw*1107/2
    //
    // this.patternAni()
    // this.modeSwitchAni()

    this.init()


  },
  beforeDestroy() {
    Raf.remove(this.update)
  },

  methods: {
    ...mapMutations('app', ['toggleMode']),
    h(){
      return window.innerHeight*window.devicePixelRatio
    },
    w(){
      return window.innerWidth*window.devicePixelRatio
    },
    init(){


      //console.log(888, window.innerWidth, window.innerHeight, window.devicePixelRatio)


      this.patternCanvas = document.createElement('canvas')
      let ph = this.h() * 289/869*2
      let pw = ph * 369/289
      this.patternCanvas.height = ph
      this.patternCanvas.width = pw
      this.patternCtx = this.patternCanvas.getContext('2d')
      let patternSrc = this.$refs.pattern

      this.liqtrans = this.$refs.liqtrans
      this.transDots = this.$refs.transDots

      this.resize()



      patternSrc.addEventListener('load', () => {
        this.patternCtx.drawImage(patternSrc, 0, 0, patternSrc.naturalWidth, patternSrc.naturalHeight, 0, 0, pw, ph)

        this.canvas = this.$refs.trans
        this.canvas.width = this.w()
        this.canvas.height = this.h()
        this.ctx = this.canvas.getContext('2d')
        this.pattern = this.ctx.createPattern(this.patternCanvas, 'repeat')
        //this.ctx.fillStyle = this.pattern
        //this.ctx.fillRect(0, 0, this.w(), this.h())
        this.trans()


      })
    },
    resize(){
      this.textH = 0.04*this.h()
      this.textSpacing = 0.005*this.h()
      this.textMargin = 0.02*this.h()
      this.textOffX1 = this.w()/2-this.textH-this.textSpacing/2
      this.textOffY1 = this.h()/2-this.textH/2
      this.textOffX2 = this.textOffX1-this.textSpacing-this.textH
      this.textOffY2 = this.textOffY1+this.textH+this.textMargin
      this.textOffX3 = this.textOffX2*1.08
      this.textOffY3 = this.textOffY2 +this.textMargin
    },
    update(){
      this.offset-=0.001
      let ofs = this.offset*1500
      this.ctx.clearRect(0, 0, this.w(), this.h())
      this.ctx.globalCompositeOperation="destination-atop"
      let p = this.liqtransP[Math.floor(this.frame)]
      //console.log(p)
      if (this.liqtransFlip) {
        this.ctx.save()
        this.ctx.translate(this.w(), this.h())
        this.ctx.scale(-1, -1)
        this.ctx.drawImage(this.liqtrans, p.x, p.y, p.w, p.h, 0, 0, this.w(), this.h())
        this.ctx.restore()
      } else {
        this.ctx.drawImage(this.liqtrans, p.x, p.y, p.w, p.h, 0, 0, this.w(), this.h())
      }
      this.ctx.globalCompositeOperation = 'source-in'

      this.ctx.translate(ofs, ofs)
      this.ctx.fillStyle = this.pattern
      this.ctx.fillRect(-ofs, -ofs, this.w(), this.h())
      this.ctx.translate(-ofs, -ofs)

      this.ctx.globalCompositeOperation = 'source-atop'

      this.ctx.fillStyle = "#f8deb1"
      this.ctx.font = `${this.textH}px VCA`
      this.ctx.save()
      this.ctx.translate(this.textOffX1, this.textOffY1)
      this.ctx.rotate(-0.1)
      this.fillTextWithSpacing(this.ctx, '进入', 0, 0, this.textSpacing)
      this.ctx.restore()
      this.ctx.save()
      this.ctx.translate(this.textOffX2, this.textOffY2)
      this.ctx.rotate(-0.1)
      this.fillTextWithSpacing(this.ctx, this.modeTo+'模式', 0, 0, this.textSpacing)
      this.ctx.restore()
      this.ctx.save()
      this.ctx.translate(this.textOffX3, this.textOffY3)
      this.ctx.rotate(-0.1)
      this.ctx.drawImage(this.transDots, 0, 0, this.transDots.naturalWidth, this.transDots.naturalHeight, 0, 0, this.textH*4, this.textH*0.49)
      this.ctx.restore()
    },
    fillTextWithSpacing (context, text, x, y, spacing) {
      //Start at position (X, Y).
      //Measure wAll, the width of the entire string using measureText()
      let wAll = context.measureText(text).width
      let wShorter = 0
      do
      {
        //Remove the first character from the string
        let char = text.substr(0, 1)
        text = text.substr(1)

        //Print the first character at position (X, Y) using fillText()
        context.fillText(char, x, y)

        //Measure wShorter, the width of the resulting shorter string using measureText().
        if (text == "")
          wShorter = 0
        else
          wShorter = context.measureText(text).width

        //Subtract the width of the shorter string from the width of the entire string, giving the kerned width of the character, wChar = wAll - wShorter
        let wChar = wAll - wShorter

        //Increment X by wChar + spacing
        x += wChar + spacing

        //wAll = wShorter
        wAll = wShorter

        //Repeat from step 3
      } while (text != "")
    },
    trans(){
      window.AudioPlayer.playTransBgm()
      Raf.add(this.update)
      let tl = new TimelineMax({ onComplete: () => {
          this.toggleMode()
          let tl2 = new TimelineMax({ onComplete: () => {
              Raf.remove(this.update)
              this.$emit('complete')
              window.AudioPlayer.stopTransBgm()
              window.MapTitle.animeInOut(this.currSceneIdx)
            },
          })
          this.tl2 = tl2

          tl2.add('start')
            .set(
              this,
              {
                liqtransFlip: true
              },
              `start+=0`
            )
            .to(
              this,
              1,
              {
                frame: 0,
                ease: SteppedEase.config(24)
              },
              `start+=0`
            )
        }
      })
      this.tl = tl

      tl.add('start')
        .set(
          this,
          {
            liqtransFlip: false
          },
          `start+=0`
        )
        .to(
          this,
          1,
          {
            frame: 23,
            ease: SteppedEase.config(24)
          },
          `start+=0`
        )
    }

  },
  watch: {
    // switchMode(val){
    //   if (val) {
    //     this.toggleMode()
    //   }
    // },

  },
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
.mode-switch
  +full()
  z-index: 9999
  overflow: hidden
  //pointer-events: none

  //background: $cl-orange
  .mode-trans
    +full()


  .copy
    +full()
    //opacity: 0
    display: flex
    justify-content: center
    align-items: center
    flex-direction: column
    font-size: $fs-xxl
    color: $cl-lightGold
    text-align: center
    transform-origin: center
    transform: rotateZ(-6deg)
    .line
      margin: 0.08rem
    .dots
      width: 1.3rem
      margin: 0.05rem
      //background: #e15125
      position: relative
      use
        fill: $cl-gold





</style>
